import { BASE_URL } from '../../../settings';

// Agent endpoints live inside the main backend (searchservice).
// Default route: `${BASE_URL}search/agent` → `/api/search/agent/...`
// via the API gateway. Override with REACT_APP_AGENT_URL to bypass the
// gateway during local development.
const AGENT_URL = process.env.REACT_APP_AGENT_URL || `${BASE_URL}search/agent`;

/**
 * Sends a message to the agent backend and returns the reply,
 * any triggered action, and the updated conversation history.
 *
 * @param {string} message           - User's message
 * @param {Array}  history           - Conversation history [{role, content}]
 * @param {object} userContext       - { userName, isLoggedIn, bookingCount }
 * @returns {Promise<{ reply: string, action: object|null, history: Array }>}
 */
export const sendAgentMessage = async (message, history = [], userContext = {}) => {
    const response = await fetch(`${AGENT_URL}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, history, userContext }),
    });

    if (!response.ok) {
        throw new Error(`Agent API error: ${response.status}`);
    }

    return response.json();
};

const MAX_CARDS_PER_SEARCH = 30;

/**
 * Fetches the next page of spaces for an existing search (no LLM).
 *
 * @param {object} searchContext - Criteria from the original search
 * @param {number} offset - API offset from pagination.nextOffset (not card count)
 */
export const loadMoreSearchSpaces = async (searchContext, offset) => {
    const response = await fetch(`${AGENT_URL}/search-more`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ searchContext, offset }),
    });

    if (!response.ok) {
        throw new Error(`Search-more API error: ${response.status}`);
    }

    return response.json();
};

export { MAX_CARDS_PER_SEARCH };
